import { Component } from "@angular/core";
import { PurchaseHistoryService } from "../purchaseHistory/purchaseHistory.service";
import { ToastsManager } from "ng2-toastr/ng2-toastr";
import { FormControl } from "@angular/forms";
import { Constants } from "../constants/constants";
import { FormStatus } from "../enums/enums";
import { ActivatedRoute } from "@angular/router";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/operator/distinctUntilChanged";

@Component({
	selector: "purchaserApproval",
	templateUrl: "/app/purchaserApproval/purchaserApproval.template.html",
	providers: [PurchaseHistoryService]
})

export class PurchaserApprovalComponent {
	purchaserHistory = [] as Array<IPurchaseHistoryModel>;
	purchaserApprovals = [] as Array<IPurchaseHistoryModel>;
	search = "";
	filter = new FormControl();
	purchasers: Array<IUserModel>;
	lastSortedColumnApproval = "id";
	lastSortedColumnHistory = "id";
	isDescApproval = true;
	isDescHistory = true;
	purchaserApprovalsRowCount = 0;
	purchaserApprovalsPageSize = 20;
	purchaserApprovalsPageNumber = 1;
	purchaserHistoryRowCount = 0;
	purchaserHistoryPageSize = 20;
	purchaserHistoryPageNumber = 1;
	restUrl = Constants.attachtmentsUrl;
	loadingPendingApprovals: boolean = true;
	loadingCompletedApprovals: boolean = true;
	attachmentname: string = "";
	constructor(private purchaseHistoryService: PurchaseHistoryService, private toast: ToastsManager, private constants: Constants, private activatedRoute: ActivatedRoute) { }

	ngOnInit() {
		this.search = this.activatedRoute.snapshot.params["searchTerm"] ? this.activatedRoute.snapshot.params["searchTerm"] : "";

		this.getPurchasers();

		this.filter.valueChanges.debounceTime(500).distinctUntilChanged().subscribe((term: string) => {
			if(term) {
				this.searchPurchaserApprovals(term, 1);
				this.searchPurchaserHistory(term, 1);
			} else {
				this.getPurchaserApprovals();
				this.getPurchaserHistory();
			}
		});
	}

	getPurchaserApprovals(): void {
		this.loadingPendingApprovals = true;
		this.purchaserApprovals = [];
		this.purchaseHistoryService.getPurchaserApprovals(this.constants.user.email, this.purchaserApprovalsPageNumber, this.purchaserApprovalsPageSize).subscribe((purchaserApprovals: { approvals: Array<IPurchaseHistoryModel>, rowCount: number }): void => {
			if(purchaserApprovals) {
				this.purchaserApprovals = purchaserApprovals.approvals;
				this.purchaserApprovalsRowCount = purchaserApprovals.rowCount;
			}
			this.loadingPendingApprovals = false;
		});
	}

	getPurchaserHistory(): void {
		this.loadingCompletedApprovals = true;
		this.purchaserHistory = [];
		this.purchaseHistoryService.getPurchaserHistory(this.constants.user.email, this.purchaserHistoryPageNumber, this.purchaserHistoryPageSize).subscribe((purchaserHistory: { history: Array<IPurchaseHistoryModel>, rowCount: number }): void => {
			if(purchaserHistory) {
				this.purchaserHistory = purchaserHistory.history;
				this.purchaserHistoryRowCount = purchaserHistory.rowCount;
			}
			this.loadingCompletedApprovals = false;
		});
	}

	getPurchasers(): void {
		this.purchaseHistoryService.getPurchasers().subscribe((result: Array<IUserModel>): void => {
			if(result)
				this.purchasers = result;
		});
	}

	showHideDetails(purchaseHistory: IPurchaseHistoryModel): void {
		if(purchaseHistory.isVisible === undefined)
			purchaseHistory.isVisible = false;

		purchaseHistory.isVisible = !purchaseHistory.isVisible;
	}

	approvePurchase(purchaseHistory: IPurchaseHistoryModel): void {
		if (!purchaseHistory.submitting) {
			purchaseHistory.submitting = true;
			this.updateApprovalStatus(purchaseHistory, FormStatus.Approved, this.constants.user.username);
		}
	}

	denyPurchase(purchaseHistory: IPurchaseHistoryModel): void {
		if (!purchaseHistory.submitting) {
			purchaseHistory.submitting = true;
			this.updateApprovalStatus(purchaseHistory, FormStatus.Denied, this.constants.user.username);
		}
	}

	completePurchase(purchaseHistory: IPurchaseHistoryModel): void {
		this.loadingPendingApprovals = true;
		if (!purchaseHistory.submitting) {
			purchaseHistory.submitting = true;
			this.updateApprovalStatus(purchaseHistory, FormStatus.Completed, this.constants.user.username);
		}
	}

	cancelPurchase(purchaseHistory: IPurchaseHistoryModel): void {
		this.loadingPendingApprovals = true;
		if (!purchaseHistory.submitting) {
			purchaseHistory.submitting = true;
			this.updateApprovalStatus(purchaseHistory, FormStatus.Cancelled, this.constants.user.username);
		}
	}

	updateApprovalStatus(approval: IPurchaseHistoryModel, toFormStatusId: number, username: string): void {
		this.purchaseHistoryService.updateApprovalStatus(approval.id, toFormStatusId, username).subscribe((result: boolean): void => {
			if(result) {
				this.getPurchaserApprovals();
				this.getPurchaserHistory();

				this.toast.success(`Purchase ${approval.id} has been updated.`, "Success", { toastLife: 5000 });
			} else
				this.toast.error("Error processing you request.", "Error", { toastLife: 10000 });
			this.loadingPendingApprovals = false;
		});
	}

	updatePurchaser(purchaserApproval: IPurchaseHistoryModel): void {
		this.purchaseHistoryService.updatePurchaser(purchaserApproval.id, purchaserApproval.purchaserId).subscribe((result: boolean): void => {
			if(result)
				this.toast.success("Purchaser updated.", "Success", { toastLife: 5000 });
			else
				this.toast.error("There was a problem updating the purchaser.", "Error", { toastLife: 5000 });
		});
	}

	showApprovalArrows(column: string): boolean {
		return this.isDescApproval && this.lastSortedColumnApproval === column;
	}

	setSortOrderApproval(columnName: string): void {
		if(this.lastSortedColumnApproval === columnName)
			this.isDescApproval = !this.isDescApproval;
		else
			this.isDescApproval = true;

		this.lastSortedColumnApproval = columnName;
	}

	showHistoryArrows(column: string): boolean {
		return this.isDescHistory && this.lastSortedColumnHistory === column;
	}

	setSortOrderHistory(columnName: string): void {
		if(this.lastSortedColumnHistory === columnName)
			this.isDescHistory = !this.isDescHistory;
		else
			this.isDescHistory = true;

		this.lastSortedColumnHistory = columnName;
	}

	purchaserUpdatePurchase(history: IPurchaseHistoryModel) {
		this.purchaseHistoryService.purchaserUpdatePurchase(history).subscribe((result: boolean): void => {
			if(result)
				this.toast.success("Purchase has been updated.", "Success", { toastLife: 5000 });
			else
				this.toast.error("There was a problem updating the purchase.", "Error", { toastLife: 5000 });
		});
	}

	calcExtendedCost(item: IItemModal, approval: IPurchaseHistoryModel): number {

		let total: number;

		if(item.actualCost && item.actualCost > 0)
			total = item.actualCost * item.quantity;
		else
			total = item.cost * item.quantity;

		this.updateApprovalAmount(approval);

		return total;
	}

	searchPurchaserApprovals(term: string, pageNumber: number): void {
		if(term) {
			this.purchaseHistoryService.getPurchaserApprovalsSearch(this.constants.user.email, pageNumber, this.purchaserApprovalsPageSize, term).subscribe((purchaserApprovals: { approvals: Array<IPurchaseHistoryModel>, rowCount: number }): void => {
				if(purchaserApprovals) {
					this.purchaserApprovalsPageNumber = pageNumber;
					this.purchaserApprovals = purchaserApprovals.approvals;
					this.purchaserApprovalsRowCount = purchaserApprovals.rowCount;
					this.loadingPendingApprovals = false;
				}
			});
		}
	}

	searchPurchaserHistory(term: string, pageNumber: number): void {
		if(term) {
			this.purchaseHistoryService.getPurchaserHistorySearch(this.constants.user.email, pageNumber, this.purchaserHistoryPageSize, term).subscribe((purchaserHistory: { history: Array<IPurchaseHistoryModel>, rowCount: number }): void => {
				if(purchaserHistory) {
					this.purchaserApprovalsPageNumber = pageNumber;
					this.purchaserHistory = purchaserHistory.history;
					this.purchaserHistoryRowCount = purchaserHistory.rowCount;
					this.loadingCompletedApprovals = false;
				}
			});
		}
	}

	updateApprovalAmount(approval: IPurchaseHistoryModel) {
		let total = 0;

		approval.items.forEach((item: IItemModal): void => {
			total += item.actualCost && item.actualCost > 0 ? (item.quantity * item.actualCost) : (item.quantity * item.cost);
		});

		approval.amount = total;
	}
	downloadAttachment(formTypeId: number,formId: number,fileName: string)
	{
		this.purchaseHistoryService.downloadAttachment(formTypeId,formId,fileName).subscribe((blob) => {
			const fileURL = (window.URL || window.webkitURL).createObjectURL(blob);

			// Open in new browser tab
			const tab = window.open(fileURL, '_blank');

			if (!tab) {
				alert('Please allow popups for this site to preview files.');
			}

			// Cleanup memory later
			setTimeout(() => {
				try {
					(window.URL || window.webkitURL).revokeObjectURL(fileURL);
				} catch (e) { }
			}, 10000);
		}, err => {
			console.error(err);
			alert('Error opening file');
		}
		);
	}	
}